import React from 'react';
import PropTypes from 'prop-types';
import strings from 'localization/strings';
import routes from 'routes';
import storageGroupCategories from 'enums/storageGroupCategories';

import MarginBox from 'common/MarginBox';
import Breadcrumbs from 'common/Breadcrumbs';

const LandingPageBreadcrumbs = ({ landingPage, location }) => {
    const breadcrumbs = [
        {
            label: strings.home,
            url: routes.index
        },
        {
            label: strings.formatString(storageGroupCategories[landingPage.key].geographyListTitle, location),
        }
    ];

    return (
        <MarginBox bottom={4}>
            <Breadcrumbs items={breadcrumbs} />
        </MarginBox>
    );
};

LandingPageBreadcrumbs.propTypes = {
    landingPage: PropTypes.object.isRequired,
    location: PropTypes.string
};

export default LandingPageBreadcrumbs;
